var _path, _path2, _path3, _path4, _rect, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRespIllustrationEtudeSection1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 167,
    viewBox: "0 0 366 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122 121.5C122 135.583 110.583 147 96.5 147C82.4167 147 71 135.583 71 121.5V46.5C71 32.4167 82.4167 21 96.5 21C110.583 21 122 32.4167 122 46.5L122 121.5Z",
    fill: "#E29578"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195 107.5C195 123.24 182.24 136 166.5 136C150.76 136 138 123.24 138 107.5V28.5C138 12.7599 150.76 0 166.5 0C182.24 0 195 12.7599 195 28.5V107.5Z",
    fill: "#679ACB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146 119.5C146 129.717 137.717 138 127.5 138C117.283 138 109 129.717 109 119.5V45.5C109 35.2827 117.283 27 127.5 27C137.717 27 146 35.2827 146 45.5V119.5Z",
    fill: "#FFDDD2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165 116.5C165 124.508 158.508 131 150.5 131C142.492 131 136 124.508 136 116.5V60.5C136 52.4919 142.492 46 150.5 46C158.508 46 165 52.4919 165 60.5V116.5Z",
    fill: "#E8F8FE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 365.469,
    y: 94.4287,
    width: 62.6686,
    height: 365.331,
    rx: 31.3343,
    transform: "rotate(90.1275 365.469 94.4287)",
    fill: "#005B7F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.335 166.653C120.833 166.653 111.508 157.329 111.508 145.826C111.508 134.324 120.833 125 132.335 125L253.822 125C265.324 125 274.649 134.324 274.649 145.826C274.649 157.329 265.324 166.653 253.822 166.653L132.335 166.653Z",
    fill: "#679ACB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespIllustrationEtudeSection1);
export default __webpack_public_path__ + "static/media/Resp_IllustrationETUDE_section1.4573da8ba822beefa7c503ccd04158f9.svg";
export { ForwardRef as ReactComponent };